import { createAction } from "redux-actions";
import { reduxKey } from "./constants";
import {
  FeaturesInitData,
  LaunchFeaturePayload,
  ToggleFavouritePayload,
  ToggleFeaturePayload,
  UnlaunchFeaturePayload,
} from "./types";

export const initFeaturesPage = createAction(
  `${reduxKey}.INIT_FEATURES_PAGE`,
  (data: FeaturesInitData) => ({ data })
);

export const reloadFeaturesInit = createAction(
  `${reduxKey}.RELOAD_FEATURES_INIT`,
  () => ({})
);
export const reloadFeaturesInitSuccess = createAction(
  `${reduxKey}.RELOAD_FEATURES_INIT_SUCCESS`,
  (data: FeaturesInitData) => ({ data })
);
export const reloadFeaturesInitFailure = createAction(
  `${reduxKey}.RELOAD_FEATURES_INIT_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);

export const toggleFeature = createAction(
  `${reduxKey}.TOGGLE_FEATURE`,
  (payload: ToggleFeaturePayload) => payload
);
export const toggleFeatureSuccess = createAction(
  `${reduxKey}.TOGGLE_FEATURE_SUCCESS`,
  () => ({})
);
export const toggleFeatureFailure = createAction(
  `${reduxKey}.TOGGLE_FEATURE_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);

export const resetFeatures = createAction(
  `${reduxKey}.RESET_FEATURES`,
  () => ({})
);
export const resetFeaturesSuccess = createAction(
  `${reduxKey}.RESET_FEATURES_SUCCESS`,
  () => ({})
);
export const resetFeaturesFailure = createAction(
  `${reduxKey}.RESET_FEATURES_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);

export const launchFeature = createAction(
  `${reduxKey}.LAUNCH_FEATURE`,
  (payload: LaunchFeaturePayload) => payload
);
export const launchFeatureSuccess = createAction(
  `${reduxKey}.LAUNCH_FEATURE_SUCCESS`,
  () => ({})
);
export const launchFeatureFailure = createAction(
  `${reduxKey}.LAUNCH_FEATURE_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);

export const unlaunchFeature = createAction(
  `${reduxKey}.UNLAUNCH_FEATURE`,
  (payload: UnlaunchFeaturePayload) => payload
);
export const unlaunchFeatureSuccess = createAction(
  `${reduxKey}.UNLAUNCH_FEATURE_SUCCESS`,
  () => ({})
);
export const unlaunchFeatureFailure = createAction(
  `${reduxKey}.UNLAUNCH_FEATURE_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);

export const toggleFavourite = createAction(
  `${reduxKey}.TOGGLE_FAVOURITE`,
  (payload: ToggleFavouritePayload) => payload
);
export const toggleFavouriteSuccess = createAction(
  `${reduxKey}.TOGGLE_FAVOURITE_SUCCESS`,
  () => ({})
);
export const toggleFavouriteFailure = createAction(
  `${reduxKey}.TOGGLE_FAVOURITE_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
